<template>
  <div class="content content-depotfinder">
    <div class="content__inner">
      <div class="wrapper">
        <NextArrowButton :nextStep="nextStep" />

        <Depositmodels />

        <div class="depotfinder__question text-centered">
          <UiHeadline
            tag="h1"
            size="large"
            theme="primary"
            align="center"
            class="depotfinder__headline"
          >
            {{ $t("depotfinder.decision.headline") }}
          </UiHeadline>

          <div class="mt-3">
            <DecisionSelect />
          </div>

          <NextButton :nextStep="nextStep" />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import UiHeadline from "./../../components/Ui/Headline.vue";
import Depositmodels from "./../../components/DepositModels.vue";
import NextArrowButton from "./../../components/NextArrowButton.vue";
import NextButton from "./../../components/NextButton.vue";
import DecisionSelect from "./../../components/DecisionSelect.vue";

export default {
  components: {
    Depositmodels,
    NextButton,
    NextArrowButton,
    DecisionSelect,
    UiHeadline
  },
  data() {
    return {
      options: this.$t("depotfinder.decision.options")
    };
  },
  computed: {
    nextStep() {
      let nextStep = "";
      if (this.$store.getters.getDecisionState == "bank") {
        nextStep = "depotfinder.assets";
      } else if (this.$store.getters.getDecisionState != "") {
        nextStep = "depotfinder.age";
      }
      return nextStep;
    }
  },
  methods: {
    goToNextStep() {
      this.$router.push({ name: this.nextStep });
    },
    setRecommendedDeposit(value) {
      this.$store.dispatch("updateRecommendedDeposit", value);
    }
  },
  mounted() {
    this.setRecommendedDeposit("");
  }
};
</script>
